import { Pipe, PipeTransform } from '@angular/core';
import { EOrderStatus } from 'src/app/models/data/sales-order.model';

@Pipe({
  name: 'convertOrderStatusToNumber'
})
export class ConvertOrderStatusToNumberPipe implements PipeTransform {

  transform(status: EOrderStatus, ...args: unknown[]): number {
    try {
      switch(status){
        case EOrderStatus.DRAFT: return 1
        case EOrderStatus.PENDING: return 2
        case EOrderStatus.CONFIRMED: return 3
        case EOrderStatus.GENERATED: return 4
        case EOrderStatus.DISPATCHED: return 5
      }
    } catch (error) {
      
    }
  }

}
